enum Sentiment {
    POSITIVE = 'POSITIVE',
    NEGATIVE = 'NEGATIVE',
    UNKNOWN = 'UNKNOWN',
}

export default Sentiment;
